import { Button, Checkbox, Heading, Icon, IconButton, SimpleGrid, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { useState } from "react";
import { AiFillWarning, AiOutlineSplitCells } from "react-icons/ai";
import { BiCheckSquare } from "react-icons/bi";
import { FaFile, FaRandom, FaRedo, FaSave, FaTrash } from "react-icons/fa";
import { GiCancel } from "react-icons/gi";
import { HiZoomIn, HiZoomOut } from "react-icons/hi";



export default function SplittedDocuments() {
    const [items] = useState([
        {
            id: 1,
            name: "Star Trek Voucher😂"
        },
        {
            id: 2,
            name: "Inam Neil Degrasse Tyson Voucher"
        },
        {
            id: 3,
            name: "Bank Payment Voucher",
        },
        {
            id: 4,
            name: "Cigarette Expense Voucher",
        },
        {
            id: 5,
            name: "Purchase Invoice",
        },
        {
            id: 6,
            name: "Refund Document",
        },
    ]);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'column', "2xl": "row" }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 6, "2xl": 0 }}
            >
                <Stack
                    align={'start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'} justify={'start'} align={'center'}>
                        <Icon
                            as={AiOutlineSplitCells}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Splitted Documents</Heading>
                            <SimpleGrid templateColumns={'1fr 1fr 1fr'}>
                                <Text>Name: <strong>EBTest</strong></Text>
                                <Text>Industry: <strong>Accountancy Firm</strong></Text>
                                <Text>Country: <strong>Pakistan</strong></Text>
                                <Text>Credit: <strong>-18</strong></Text>
                                <Text>Software: <strong>Other (Excel Output)</strong></Text>
                                <Text>Duplicate: <strong>Flag</strong></Text>
                                <Text>VAT: <strong>Registered</strong></Text>
                                <Text>VAT Scheme: <strong>Accrual Scheme</strong></Text>
                                <Text>Subscription Status: <strong>In Trial</strong></Text>
                                <Text>Subscription Plan: <strong>Standard</strong></Text>
                                <Text>Processing Status: <strong>Active</strong></Text>
                                <Text>Data Entry By: <strong>Someone</strong></Text>
                                <Text>Data Entry Time: <strong></strong></Text>
                                <Text>Source: <strong>Mobile</strong></Text>
                            </SimpleGrid>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <SimpleGrid
                    templateColumns={{ base: '1fr', md: '1fr 6fr' }}
                    spacing={6}
                >
                    <Stack>
                        <TableContainer>
                            <Table size='sm'>
                                <Thead h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                                    <Tr>
                                        <Th></Th>
                                        <Th
                                            color={'white'}
                                            isNumeric
                                        >
                                            ID
                                        </Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        items.map(item => (
                                            <Tr>
                                                <Td
                                                >
                                                    <Checkbox
                                                        colorScheme='primary'
                                                    />
                                                </Td>
                                                <Td
                                                    isNumeric
                                                >
                                                    {item.id}
                                                </Td>
                                            </Tr>
                                        ))
                                    }
                                    {/* <Tr>
                                        <Td colSpan={2} textAlign={'center'}>There is no document in this folder</Td>
                                    </Tr> */}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Stack>
                    <Stack>
                        <Stack
                            direction={'row'}
                            spacing={4}
                            justify={'space-between'}
                        >
                            <Stack
                                direction={'row'}
                                spacing={2}
                                w={'full'}
                            >
                                <Button
                                    w={'full'}
                                    size={'sm'}
                                    leftIcon={<AiFillWarning />}
                                    color={'white'}
                                    bg={'orange.400'}
                                    _hover={{ bg: 'orange.500' }}
                                    _active={{ bg: 'orange.600' }}
                                >
                                    Reset
                                </Button>

                                <Button
                                    w={'full'}
                                    size={'sm'}
                                    leftIcon={<FaTrash />}
                                    color={'white'}
                                    bg={'red.400'}
                                    _hover={{ bg: 'red.500' }}
                                    _active={{ bg: 'red.600' }}
                                >
                                    Delete
                                </Button>

                                <Button
                                    w={'full'}
                                    size={'sm'}
                                    leftIcon={<FaSave />}
                                    color={'white'}
                                    bg={'green.400'}
                                    _hover={{ bg: 'green.500' }}
                                    _active={{ bg: 'green.600' }}
                                >
                                    Save
                                </Button>

                                <Button
                                    w={'full'}
                                    size={'sm'}
                                    leftIcon={<FaRedo />}
                                    color={'white'}
                                    bg={'primary.400'}
                                    _hover={{ bg: 'primary.500' }}
                                    _active={{ bg: 'primary.600' }}
                                >
                                    Undo Split
                                </Button>

                                <Button
                                    w={'full'}
                                    size={'sm'}
                                    leftIcon={<BiCheckSquare />}
                                    color={'white'}
                                    bg={'blue.400'}
                                    _hover={{ bg: 'blue.500' }}
                                    _active={{ bg: 'blue.600' }}
                                >
                                    Select All
                                </Button>

                                <Button
                                    w={'full'}
                                    size={'sm'}
                                    leftIcon={<FaFile />}
                                    color={'white'}
                                    bg={'primary.400'}
                                    _hover={{ bg: 'primary.500' }}
                                    _active={{ bg: 'primary.600' }}
                                >
                                    Reclassify - BS
                                </Button>

                                <Button
                                    w={'full'}
                                    size={'sm'}
                                    leftIcon={<BiCheckSquare />}
                                    color={'white'}
                                    bg={'primary.400'}
                                    _hover={{ bg: 'primary.500' }}
                                    _active={{ bg: 'primary.600' }}
                                >
                                    Select All
                                </Button>

                                <IconButton
                                    size={'sm'}
                                    aria-label="Zoom in"
                                    icon={<HiZoomIn />}
                                    color={'white'}
                                    bg={'primary.400'}
                                    _hover={{ bg: 'primary.500' }}
                                    _active={{ bg: 'primary.600' }}
                                />

                                <IconButton
                                    size={'sm'}
                                    aria-label="Zoom out"
                                    color={'white'}
                                    icon={<HiZoomOut />}
                                    bg={'primary.400'}
                                    _hover={{ bg: 'primary.500' }}
                                    _active={{ bg: 'primary.600' }}
                                />
                            </Stack>
                        </Stack>
                        <Stack
                            direction={'row'}
                            spacing={2}
                            w={'full'}
                        >
                            <Button
                                w={'full'}
                                size={'sm'}
                                leftIcon={<FaRandom />}
                                color={'white'}
                                bg={'blue.400'}
                                _hover={{ bg: 'blue.500' }}
                                _active={{ bg: 'blue.600' }}
                            >
                                Merge
                            </Button>

                            <Button
                                w={'full'}
                                size={'sm'}
                                leftIcon={<GiCancel />}
                                color={'white'}
                                bg={'red.400'}
                                _hover={{ bg: 'red.500' }}
                                _active={{ bg: 'red.600' }}
                            >
                                Remove Selection
                            </Button>
                        </Stack>
                        <Stack
                            direction={'row'}
                            w={'full'}
                        >
                            <Stack w={'full'} h={'md'} align={'center'} justify={'center'} textAlign={'center'} bg={'gray.500'}>
                                <Heading color={'white'}>PDF Viewer 1</Heading>
                                <Text color={'whiteAlpha.900'}>I'm currently thinking about creating a dynamic method <br /> for PDFs and Document Viewer <br /> I'll update the document viewer once, I find a solution for that</Text>
                            </Stack>
                            <Stack w={'full'} h={'md'} align={'center'} justify={'center'} textAlign={'center'} bg={'gray.500'}>
                                <Heading color={'white'}>PDF Viewer 2</Heading>
                                <Text color={'whiteAlpha.900'}>I'm currently thinking about creating a dynamic method <br /> for PDFs and Document Viewer <br /> I'll update the document viewer once, I find a solution for that</Text>
                            </Stack>
                        </Stack>
                    </Stack>
                </SimpleGrid>
            </Stack>
        </Stack >
    )
}